"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_SURFACE_AGENT_IDS = void 0;
exports.CHAT_SURFACE_AGENT_IDS = {
    results: 'cadstrom-results-assistant',
    wizard: 'cadstrom-wizard-assistant',
    packageStore: 'cadstrom-package-store-assistant',
    datasheet: 'cadstrom-datasheet-assistant',
    default: 'cadstrom-project-assistant',
};
//# sourceMappingURL=chat-surface-agents.js.map